import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';

export const blockInternalOrganizationUserApi = async (userId: string): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = `/organization/internal/users/${userId}/block/`;

  return authApiService.POST(uri, {});
};
